import MyLocationIcon from "@mui/icons-material/MyLocation";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import GpsOffIcon from "@mui/icons-material/GpsOff";
import styles from "./SearchBar.module.scss";
import { IconSearch, IconX } from "../../../../shared/icons";

type Status = "idle" | "loading" | "granted" | "denied";

interface Props {
  value: string;
  onChange: (v: string) => void;
  locationStatus: Status;
  onRequestLocation: () => void;
}

const SearchBar = ({ value, onChange, locationStatus, onRequestLocation }: Props) => (
  <div className={styles.wrap}>
    <span className={styles.icon}><IconSearch /></span>
    <input
      className={styles.input}
      type="text"
      placeholder="Rechercher un restaurant ou une adresse…"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      autoComplete="off"
    />
    {value && (
      <button className={styles.clear} onClick={() => onChange("")} aria-label="Effacer">
        <IconX size={12} />
      </button>
    )}
    <button
      className={`${styles.locationBtn} ${styles[`status-${locationStatus}`]}`}
      onClick={onRequestLocation}
      aria-label="Ma position"
      title={
        locationStatus === "granted" ? "Recentrer sur ma position"
          : locationStatus === "denied" ? "Accès refusé — cliquez pour réessayer"
          : locationStatus === "loading" ? "Localisation en cours…"
          : "Utiliser ma position"
      }
    >
      {locationStatus === "granted" ? (
        <GpsFixedIcon style={{ fontSize: 18 }} />
      ) : locationStatus === "denied" ? (
        <GpsOffIcon style={{ fontSize: 18 }} />
      ) : (
        <MyLocationIcon style={{ fontSize: 18 }} className={locationStatus === "loading" ? styles.spin : ""} />
      )}
    </button>
  </div>
);

export default SearchBar;